export enum FileSortBy {
  CreatedAt = 'createdAt',
  PinnedAt = 'pinnedAt',
  Extension = 'extension',
  NbrOfDownloads = 'nbrOfDownloads',
}
